import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import '@mescius/wijmo.styles/wijmo.css';
import '@mescius/wijmo.cultures/wijmo.culture.ja';
import * as wjGrid from '@mescius/wijmo.grid';
import { FlexGrid, FlexGridCellTemplate } from '@mescius/wijmo.react.grid';
import { CollectionView } from '@mescius/wijmo';
import * as wjInput from '@mescius/wijmo.react.input';
import { Tooltip, PopupPosition } from '@mescius/wijmo';

import { MasterPageHeader } from '../components/PageHeader';
import { QuestionIcon } from '../components/icons/QuestionIcon';
import { Confirmation, Information } from '../components/modals/common';
import { TouchDeviceInvisible } from '../components/TouchDeviceInvisible';
import {
  CompleteBatchStatus,
  NoHaveBatchStatus,
  ToolTip,
  TabPanel,
} from '../components/ProgressBase';
import {
  SCHEDULE_COLUMN_NAME,
  COLUMN_DISPLAY_MAIN_FLAG,
  COLUMN_DISPLAY_SUB_FLAG,
  COLUMN_NUMBER,
  VIEW_RANGE_BOTTOM_HEIGHT,
  TOOLTIP_WARNING,
  IS_PLAN_TAB_FLG,
  DATA_TYPE,
  KEY_GROUP_OF_PLACE_TYPE,
  KEY_GROUP_OF_WORK_TYPE,
  INIT_POSITION,
  setMathRoundNumber,
  setDisplayTab,
  setStyleForCell,
  setIconArrowForCell,
  setFormatData,
  setMaxHeightTable,
  isExistSubItem,
  initColumnGroupByTab,
} from '../utilities/constWijmo';
import {
  DATE_TIME_FORMAT,
  HEADER_CONSTANTS_PROGRESS,
  TITLE_BROWSER_PROGRESS,
  NUMBER_OF_FIELD_ITEM_TYPE,
  PROGRESS_REQUEST_PARAMS,
  TIME_TO_GET_BATCH_STATUS,
} from '../utilities/constants';
import { messageUtility } from '../utilities/messageUtility';
import { csvDownloader } from '../utilities/commonUtil';
import ProgressService from '../services/Progress';
import SessionStorageService from '../services/utilities/SessionStorageService';
import FieldService from '../services/Fields';
import SessionsService from '../services/Sessions';
import IconProgress from '../images/icon-progress.svg';

export class ProgressSchedule extends Component {
  constructor(props) {
    super(props);
    this.fieldId = SessionStorageService.getFieldId();
    this.date = new Date(
      new Date().toLocaleString('en-US', { timeZone: 'Asia/Tokyo' })
    );
    this.formatDate = moment(this.date).format(
      DATE_TIME_FORMAT.slashDateFormat
    );
    this.tooltip = new Tooltip({
      showAtMouse: true,
      isContentHtml: false,
      cssClass: 'wj-tooltip-progress',
    });
    this.state = {
      isTableLoading: true,
      notHaveItems: true,
      newListItems: [],
      selectedItemId: [],
      currentItemIds: [],
      total: null,
      visibleDialogName: false,
      visibleConfirmDialogCSV: false,
      titleErr: null,
      buttonTextErr: null,
      isShowPopupError: false,
      messageError: null,
      errMessage: null,
      startDate: null,
      endDate: null,
      inputStartDate: null,
      inputEndDate: null,
      isCheckAll: false,
      isWorkType: true,
      isScrollFlag: false,
      isCollapseFlag: false,
      isLastItemCollapsed: false,
      workTypeId: DATA_TYPE[0],
      displayBatch: false,
      aggregatedBatchDateTime: null,
      batchStatusText: null,
      dataTypesUnregistered: [],
      params_schedule: {
        axis_type: DATA_TYPE[0],
        offset: PROGRESS_REQUEST_PARAMS.offset,
        limit: PROGRESS_REQUEST_PARAMS.limit,
        is_limit: PROGRESS_REQUEST_PARAMS.isLimit,
      },
      params_id: {
        last_field_main_work_type_id: null,
        last_field_sub_work_type_id: null,
        last_a_item_id: null,
        last_b_item_id: null,
        last_c_item_id: null,
        last_d_item_id: null,
      },
      params_old_id: {
        old_last_field_main_work_type_id: null,
        old_last_field_sub_work_type_id: null,
        old_last_a_item_id: null,
        old_last_b_item_id: null,
        old_last_c_item_id: null,
        old_last_d_item_id: null,
      },
      notificationList: [],
      apiStartedAt: null,
      marginTab: null,
      isPlanTagFlg: IS_PLAN_TAB_FLG,
      listTypeLocation: [],
      totalRecords: null,
    };
    this.isSubmitingFlag = false;
    this.isGettingDataFlag = true;
    this.isFirstMount = true;
    this.scrollPositionGrid = INIT_POSITION;
    this.countTimesOfScrollMain = INIT_POSITION;
    this.countTimesOfScrollSub = INIT_POSITION;
    this.countTimesOfScrollPlace = INIT_POSITION;
    this.childItemsPath = ['child', 'child', 'child', 'child', 'child'];
    this.isProgressFlg = parseInt(SessionStorageService.getUseProgressFlag());
    this.listItems = new CollectionView([]);
    this.columnGroupInit = initColumnGroupByTab(
      SCHEDULE_COLUMN_NAME,
      IS_PLAN_TAB_FLG
    );
  }

  async componentDidMount() {
    const { isPlanTagFlg } = this.state;
    await this.getSelectField();
    await this.getSchedulesWorkTypeAxis();
    await this.getFieldSettings();
    this.getFieldItem();
    this.getAggregateHistories();
    this.setMarginTab();
    SessionStorageService.setIsPlanTabFlg(isPlanTagFlg);
    SessionStorageService.removeItemIds();
    SessionStorageService.removeAxisType();
  }

  getSelectField = async () => {
    const response = await SessionsService.getfield();
    this.fieldId = response.data.entities.field_id;
  };

  getFieldItem = async () => {
    const response = await FieldService.fieldItem(this.fieldId);
    if (response.result) {
      const fieldItem = _.get(response, 'data.entities.field_item');
      let listTypeLocation = [
        {
          id: DATA_TYPE[0],
          name: '工種',
        },
      ];
      for (
        let i = NUMBER_OF_FIELD_ITEM_TYPE.itemA;
        i <= NUMBER_OF_FIELD_ITEM_TYPE.itemD;
        i++
      ) {
        if (fieldItem[`field_item_list${i}_display_flag`]) {
          listTypeLocation.push({
            id: i,
            name: _.get(fieldItem, `field_item_list${i}_title`),
          });
        }
      }
      this.setState({ listTypeLocation });
    }
  };

  getAggregateHistories = async () => {
    const response = await ProgressService.getProgressAggregateHistories(
      this.fieldId
    );
    if (response.result) {
      const data = _.get(
        response,
        'data.entities.progress_aggregate_histories'
      );
      const aggregatedBatchDateTime = _.get(
        response,
        'data.entities.progress_aggregate_histories.aggregated_at'
      );
      if (!_.isNull(data)) {
        this.setState({
          displayBatch: true,
          aggregatedBatchDateTime,
          batchStatusText: '最終集計日時:',
        });
      } else {
        this.setState(
          {
            displayBatch: false,
            aggregatedBatchDateTime: '未集計',
            batchStatusText: '最終集計日時:',
          },
          () => {
            setTimeout(() => {
              this.getAggregateHistories();
            }, TIME_TO_GET_BATCH_STATUS);
          }
        );
      }
    }
  };

  getSchedulesWorkTypeAxis = async (load = null) => {
    const {
      totalRecords,
      isScrollFlag,
      isCollapseFlag,
      isLastItemCollapsed,
      workTypeId,
      isWorkType,
      isCheckAll,
    } = this.state;
    let params_id = _.cloneDeep(this.state.params_id);
    let params_old_id = _.cloneDeep(this.state.params_old_id);
    let params_schedule = _.cloneDeep(this.state.params_schedule);
    if (_.isEqual(load, 'loadmore')) {
      params_schedule.call_api_started_at = this.state.apiStartedAt;
      params_schedule = { ...params_schedule, ...this.state.params_id };
      if (isScrollFlag) {
        ++this.countTimesOfScrollMain;
        ++this.countTimesOfScrollSub;
        ++this.countTimesOfScrollPlace;
        params_schedule.limit = PROGRESS_REQUEST_PARAMS.limit;
        if (isLastItemCollapsed) {
          if (totalRecords <= PROGRESS_REQUEST_PARAMS.limit) {
            params_schedule.limit = PROGRESS_REQUEST_PARAMS.limit;
          } else if (totalRecords >= PROGRESS_REQUEST_PARAMS.parentLimit) {
            params_schedule.limit = PROGRESS_REQUEST_PARAMS.parentLimit;
          } else {
            params_schedule.limit = totalRecords;
          }
        }
      } else {
        if (totalRecords <= PROGRESS_REQUEST_PARAMS.limit) {
          params_schedule.limit = PROGRESS_REQUEST_PARAMS.limit;
        } else if (totalRecords >= PROGRESS_REQUEST_PARAMS.parentLimit) {
          params_schedule.limit = isCollapseFlag
            ? PROGRESS_REQUEST_PARAMS.parentLimit
            : PROGRESS_REQUEST_PARAMS.limit;
        } else {
          params_schedule.limit = totalRecords;
        }
      }
    }
    params_old_id.old_last_field_main_work_type_id =
      params_id.last_field_main_work_type_id;
    params_old_id.old_last_field_sub_work_type_id =
      params_id.last_field_sub_work_type_id;
    params_old_id.old_last_a_item_id = params_id.last_a_item_id;
    params_old_id.old_last_b_item_id = params_id.last_b_item_id;
    params_old_id.old_last_c_item_id = params_id.last_c_item_id;
    params_old_id.old_last_d_item_id = params_id.last_d_item_id;
    const response = await ProgressService.getProgressSchedulesAxisByWorkType(
      this.fieldId,
      params_schedule
    );
    let data = _.get(response, 'data.entities.progress_schedules');
    const dataTypesUnregistered = _.get(
      response,
      'data.entities.data_types_unregistered'
    );
    if (!_.isEmpty(dataTypesUnregistered)) {
      data = setFormatData(dataTypesUnregistered, data, workTypeId);
    }
    const errorFlag = _.get(
      response,
      'data.entities.call_api_started_at_error_flag'
    );
    const apiStartedAt = _.get(response, 'data.entities.call_api_started_at');

    params_id.last_field_main_work_type_id = _.get(
      response,
      'data.entities.last_field_main_work_type_id'
    );
    params_id.last_field_sub_work_type_id = _.get(
      response,
      'data.entities.last_field_sub_work_type_id'
    );
    params_id.last_a_item_id = _.get(response, 'data.entities.last_a_item_id');
    params_id.last_b_item_id = _.get(response, 'data.entities.last_b_item_id');
    params_id.last_c_item_id = _.get(response, 'data.entities.last_c_item_id');
    params_id.last_d_item_id = _.get(response, 'data.entities.last_d_item_id');

    if (response.result) {
      if (errorFlag) {
        return this.setState({
          titleErr: messageUtility.getMessage('E-001-430'),
          buttonTextErr: messageUtility.getMessage('I-000-180'),
          isShowPopupError: true,
          messageError: messageUtility.getMessage('E-000-062'),
        });
      }
      if (this.isFirstMount) {
        params_schedule.offset += PROGRESS_REQUEST_PARAMS.limit;
      }
      if (_.isEqual(load, 'loadmore')) {
        this.handleCountTimesOfScroll(params_id, params_old_id);
        const newIds = _.map(data, item =>
          isWorkType ? item.field_main_work_type_id : item.place_id
        );
        const diffIds = _.difference(newIds, this.state.currentItemIds);
        params_schedule.offset += params_schedule.limit;
        return this.setState({
          newListItems: data,
          currentItemIds: [...this.state.currentItemIds, ...diffIds],
          isCheckAll: _.isEmpty(diffIds) ? isCheckAll : false,
          params_schedule,
          params_id,
          params_old_id,
          totalRecords:
            totalRecords > PROGRESS_REQUEST_PARAMS.parentLimit
              ? totalRecords - params_schedule.limit
              : totalRecords,
          isLastItemCollapsed: _.isEmpty(diffIds),
        });
      }
      this.listItems.sourceCollection = data;
      this.listItems.refresh();
      return this.setState(
        {
          currentItemIds: _.map(data, item =>
            isWorkType ? item.field_main_work_type_id : item.place_id
          ),
          notHaveItems: _.isEmpty(data),
          total: _.get(response, 'data.total'),
          selectedItemId: [],
          isCheckAll: false,
          apiStartedAt,
          isTableLoading: false,
          params_schedule,
          params_id,
          params_old_id,
          dataTypesUnregistered,
        },
        () => (this.isFirstMount = false)
      );
    }
  };

  getFieldSettings = async () => {
    const response = await ProgressService.getProgressFieldSettings(
      this.fieldId
    );
    if (response.result) {
      const data = _.get(response, 'data.entities.progress_field_settings');
      const startDate = _.get(data, 'input_start_date');
      const endDate = _.get(data, 'input_end_date');
      if (data) {
        this.setState({
          startDate,
          endDate,
          inputStartDate: startDate,
          inputEndDate: endDate,
        });
      }
    }
  };

  updateFieldSettings = async () => {
    const { inputStartDate, inputEndDate } = this.state;
    const input_start_date = moment(inputStartDate).format(
      DATE_TIME_FORMAT.slashDateFormat
    );
    const input_end_date = moment(inputEndDate).format(
      DATE_TIME_FORMAT.slashDateFormat
    );
    if (this.isSubmitingFlag) {
      return;
    }
    this.isSubmitingFlag = true;
    const response = await ProgressService.updateProgressFieldSettings(
      this.fieldId,
      {
        input_start_date,
        input_end_date: _.isNull(inputEndDate) ? '' : input_end_date,
      }
    );
    this.isSubmitingFlag = false;
    if (response.result) {
      this.setState(
        {
          startDate: input_start_date,
          endDate: _.isNull(inputEndDate) ? null : input_end_date,
        },
        () => {
          this.handleVisibleDialog('visibleDialogName', false);
          this.tooltip.dispose();
        }
      );
      this.flexGrid.refresh();
    }
  };

  downloadProgressCSV = async () => {
    const apiPath = `api/private/progress/fields/${this.fieldId}/progress_schedules/work_type_axis_by_work_type.csv`;
    csvDownloader(apiPath, { axis_type: this.state.workTypeId });
    this.handleVisibleDialog('visibleConfirmDialogCSV', false);
  };

  handleFieldSettings = () => {
    const { inputStartDate, inputEndDate } = this.state;
    this.handleValidateInputDate(inputStartDate, inputEndDate);
  };

  handleVisibleDialog = (key, value) => {
    this.setState({ [key]: value });
  };

  handleCancelDialog = () => {
    const { startDate, endDate } = this.state;
    this.setState({
      inputStartDate: startDate,
      inputEndDate: endDate,
      errMessage: null,
      visibleDialogName: false,
    });
  };

  handleChangeInputDate = (sender, name, type) => {
    this.setState({
      [name]:
        _.isNull(sender.value) && _.isEqual(type, 'focusOut')
          ? new Date()
          : sender.value,
      errMessage: null,
    });
  };

  handleChangeInputEndDate = name => {
    this.setState({
      [name]: null,
      errMessage: null,
    });
  };

  handleChangeTypeOption = e => {
    const { value } = e.target;
    //define display axis is work type or place type by true/false of value
    const isWorkType = !Number(value);
    const params_schedule = {
      axis_type: value,
      offset: PROGRESS_REQUEST_PARAMS.offset,
      limit: PROGRESS_REQUEST_PARAMS.limit,
      is_limit: PROGRESS_REQUEST_PARAMS.isLimit,
    };
    this.isFirstMount = true;
    this.listItems.sourceCollection = [];
    this.listItems.refresh();
    this.setState(
      {
        params_schedule,
        isWorkType,
        workTypeId: Number(value),
        isTableLoading: true,
      },
      async () => {
        await this.getSchedulesWorkTypeAxis();
        this.flexGrid.scrollIntoView(0, 0);
      }
    );
  };

  handleAddUnitName = (domCell, unit) => {
    const unitDom = document.createTextNode(`${unit}`);
    domCell.appendChild(unitDom);
  };

  handleDisplayUnitName = (rowData, key, isWorkType, workTypeId, unit) => {
    let unit_name = unit;
    if (_.isNull(rowData[key])) {
      unit_name = `--${unit}`;
      if (
        (_.isEqual(rowData.data_type, DATA_TYPE[0]) &&
          !_.isEmpty(rowData.child) &&
          isExistSubItem(this.state.dataTypesUnregistered, rowData) &&
          _.includes(COLUMN_DISPLAY_MAIN_FLAG, key)) ||
        (!_.isEmpty(rowData.child) &&
          _.includes(COLUMN_DISPLAY_SUB_FLAG, key)) ||
        (!isWorkType &&
          _.isEqual(rowData.data_type, DATA_TYPE[workTypeId + 1]) &&
          _.includes(COLUMN_DISPLAY_MAIN_FLAG, key))
      ) {
        unit_name = '';
      }
    }
    return unit_name;
  };

  handleChangeColorText = (cell, value) => {
    const result = setMathRoundNumber(value);
    const formatType = new Intl.NumberFormat('en-US');
    const numberFormat = formatType.format(value);
    if (Number(value) > 0) {
      cell.classList += ' wj-text-green';
      cell.textContent = `+${numberFormat}`;
    }
    cell.classList += Number(result) < 0 ? ' wj-text-red' : '';
  };

  handleValidateInputDate = (startDate, endDate) => {
    let errMessage = null;
    if (_.isNull(startDate)) {
      errMessage = '開始日と終了日を指定してください。';
    }
    if (Date.parse(startDate) > Date.parse(endDate)) {
      errMessage = '開始日は終了日以前の日を指定してください。';
    }
    this.setState({ errMessage }, () => {
      _.isNull(errMessage) && this.updateFieldSettings();
    });
  };

  handleAddNewData = async () => {
    const sourceCollection = this.listItems.sourceCollection;
    if (_.isEmpty(sourceCollection)) {
      return;
    }
    const { total, isWorkType, params_schedule } = this.state;
    this.isGettingDataFlag = false;
    if (params_schedule.offset >= total) {
      return;
    }
    await this.getSchedulesWorkTypeAxis('loadmore');
    if (this.state.isShowPopupError) {
      return;
    }
    const lastChildItem = _.last(sourceCollection);
    const firstChildItem = _.first(this.state.newListItems);
    const otherNewListItems = _.filter(
      this.state.newListItems,
      item =>
        !_.isEqual(
          item[isWorkType ? 'field_main_work_type_id' : 'place_id'],
          firstChildItem[isWorkType ? 'field_main_work_type_id' : 'place_id']
        )
    );
    if (
      _.isEqual(
        lastChildItem[isWorkType ? 'field_main_work_type_id' : 'place_id'],
        firstChildItem[isWorkType ? 'field_main_work_type_id' : 'place_id']
      )
    ) {
      this.handleRecursiveData(
        lastChildItem,
        firstChildItem,
        isWorkType ? KEY_GROUP_OF_WORK_TYPE : KEY_GROUP_OF_PLACE_TYPE
      );
      this.setDataTable(otherNewListItems);
    } else {
      this.setDataTable(this.state.newListItems);
    }
  };

  handleRecursiveData = (lastItem, firstNewItem, keyGroup) => {
    if (_.includes(this.state.dataTypesUnregistered, DATA_TYPE[1])) {
      _.remove(keyGroup, key => _.isEqual(key, 'field_sub_work_type_id'));
    }
    const lastChildItem = _.last(lastItem.child);
    const firstChildItem = _.first(firstNewItem.child);
    const otherItems = _.filter(
      firstNewItem.child,
      item => !_.isEqual(item[keyGroup[0]], firstChildItem[keyGroup[0]])
    );
    if (
      !_.isUndefined(lastChildItem) &&
      _.isEqual(lastChildItem[keyGroup[0]], firstChildItem[keyGroup[0]])
    ) {
      lastItem.child = _.concat(lastItem.child, otherItems);
      this.handleRecursiveData(lastChildItem, firstChildItem, _.drop(keyGroup));
    } else {
      lastItem.child = _.concat(lastItem.child, firstNewItem.child);
    }
  };

  handleWarningInputDate = (domCell, input) => {
    const { startDate, endDate } = this.state;
    if (
      !_.isNull(input) &&
      (moment(input).isBefore(startDate) || moment(input).isAfter(endDate))
    ) {
      domCell.classList.add('wj-warning');
      this.tooltip.setTooltip(domCell, TOOLTIP_WARNING, PopupPosition.Right);
    }
  };

  handleMarginProgressTab = () => {
    const firstColumn = document.querySelector('.wj-topleft .wj-cell');
    const nameColumn = document.querySelector('.wj-column-name');
    if (!_.isNull(firstColumn) && !_.isNull(nameColumn)) {
      return firstColumn.offsetWidth + nameColumn.offsetWidth;
    }
  };

  handleCountTimesOfScroll = (paramsId, paramsOldId) => {
    let paramsPlace = {
      itemId: null,
      itemOldId: null,
    };
    switch (this.state.workTypeId) {
      case DATA_TYPE[1]:
        paramsPlace.itemId = 'last_a_item_id';
        paramsPlace.itemOldId = 'old_last_a_item_id';
        break;
      case DATA_TYPE[2]:
        paramsPlace.itemId = 'last_b_item_id';
        paramsPlace.itemOldId = 'old_last_b_item_id';
        break;
      case DATA_TYPE[3]:
        paramsPlace.itemId = 'last_c_item_id';
        paramsPlace.itemOldId = 'old_last_c_item_id';
        break;
      case DATA_TYPE[4]:
        paramsPlace.itemId = 'last_d_item_id';
        paramsPlace.itemOldId = 'old_last_d_item_id';
        break;
      default:
        return;
    }
    if (
      !this.state.isWorkType &&
      !_.isEqual(
        paramsOldId[paramsPlace.itemOldId],
        paramsId[paramsPlace.itemId]
      )
    ) {
      this.countTimesOfScrollMain = INIT_POSITION;
      this.countTimesOfScrollSub = INIT_POSITION;
      this.countTimesOfScrollPlace = INIT_POSITION;
    }
    if (
      !_.isEqual(
        paramsOldId.old_last_field_main_work_type_id,
        paramsId.last_field_main_work_type_id
      )
    ) {
      this.countTimesOfScrollMain = INIT_POSITION;
      this.countTimesOfScrollSub = INIT_POSITION;
    }
    if (
      !_.isEqual(
        paramsOldId.old_last_field_sub_work_type_id,
        paramsId.last_field_sub_work_type_id
      )
    ) {
      this.countTimesOfScrollSub = INIT_POSITION;
    }
  };

  setDataTable = newItems => {
    const rows = _.size(this.flexGrid.rows);
    this.listItems.sourceCollection.push(...newItems);
    this.listItems.refresh();
    if (!_.isEqual(this.scrollPositionGrid, INIT_POSITION)) {
      this.flexGrid.scrollIntoView(rows, -1);
    }
    this.setAddNewData();
  };

  setFormatCellTable = () => {
    const { isWorkType, workTypeId } = this.state;
    this.isGettingDataFlag = true;
    _.forEach(this.flexGrid.rows, row => {
      row.visible = !row._data.is_null;
      if (
        !isWorkType &&
        _.isEqual(row._data.data_type, DATA_TYPE[workTypeId + 1])
      ) {
        row.visible = true;
      }
      for (const [key, value] of Object.entries(row._data)) {
        if (_.includes(COLUMN_NUMBER, key) && !_.isNull(row._data[key])) {
          row._data[key] = setMathRoundNumber(value);
        }
      }
      setStyleForCell(row, isWorkType, workTypeId, true);
    });
    this.flexGrid.autoSizeColumns();
    this.tooltip.dispose();
  };

  setAddNewData = () => {
    const scrollPosition =
      this.flexGrid.scrollSize.height + this.flexGrid.scrollPosition.y;
    const heightGrid = Math.abs(
      scrollPosition - this.flexGrid.clientSize.height
    );
    if (
      heightGrid < VIEW_RANGE_BOTTOM_HEIGHT &&
      this.isGettingDataFlag &&
      !this.isFirstMount
    ) {
      this.handleAddNewData();
    }
    this.setMarginTab();
  };

  setCheckbox = (e, context) => {
    const { checked } = e.target;
    const { selectedItemId, currentItemIds, isWorkType } = this.state;
    const newIds = [
      ...selectedItemId,
      _.get(
        context,
        isWorkType ? 'item.field_main_work_type_id' : 'item.place_id'
      ),
    ];
    if (checked) {
      return this.setState({
        selectedItemId: newIds,
        isCheckAll: _.isEqual(_.size(newIds), _.size(currentItemIds)),
      });
    }
    return this.setState({
      selectedItemId: _.filter(
        selectedItemId,
        item =>
          !_.isEqual(
            _.get(
              context,
              isWorkType ? 'item.field_main_work_type_id' : 'item.place_id'
            ),
            item
          )
      ),
      isCheckAll: false,
    });
  };

  setCheckAll = e => {
    const { checked } = e.target;
    const { isWorkType } = this.state;
    const allItemIds = checked
      ? _.map(this.listItems.sourceCollection, item =>
          isWorkType ? item.field_main_work_type_id : item.place_id
        )
      : [];
    this.setState({
      selectedItemId: allItemIds,
      isCheckAll: checked,
    });
  };

  setDataDate = (startDate, planWorkDays, currentWorkDays, result) => {
    const percent = Math.round((currentWorkDays / planWorkDays) * 100);
    let textHtml = `${currentWorkDays}日 (${percent}%)`;
    if (moment(startDate).isAfter(this.formatDate)) {
      textHtml = `0日 (${percent}%)`;
    }
    if (moment(startDate).isBefore(this.formatDate) && percent > 100) {
      textHtml = `${currentWorkDays}日 (<span class="text--negative">${percent}%</span>)`;
    }
    result.innerHTML = textHtml;
  };

  setHeightScrollTable = flexGrid => {
    flexGrid.refresh();
    const scrollPosition =
      flexGrid.scrollSize.height + flexGrid.scrollPosition.y;
    const heightGrid = Math.abs(scrollPosition - flexGrid.clientSize.height);
    const { params_schedule, total } = this.state;
    if (heightGrid < VIEW_RANGE_BOTTOM_HEIGHT) {
      if (params_schedule.offset >= total) {
        return;
      }
      if (this.isGettingDataFlag) {
        this.handleAddNewData();
      }
    }
    this.setMarginTab();
  };

  setMarginTab = () => {
    this.flexGrid.refresh();
    this.setState({
      marginTab: this.handleMarginProgressTab(),
    });
  };

  setProgressTabFlag = type => {
    this.setState({ isPlanTagFlg: type });
    SessionStorageService.setIsPlanTabFlg(type);
    setDisplayTab(this.flexGrid, type);
    this.tooltip.dispose();
    this.flexGrid.autoSizeColumns();
    this.setMarginTab();
  };

  setMaxHeightGrid = () => {
    const divFixed = document.querySelector('.ProgressSchedule .wj-flexgrid');
    if (divFixed) {
      const params = {
        heightOfTable: 'calc(100vh - 260px)',
        heightOfTableHaveNoti: 'calc(100vh - 300px)',
        heghtOfTableIpad: 'calc(100vh - 355px)',
        heightOfTableIpadHaveNoti: 'calc(100vh - 395px)',
      };
      setMaxHeightTable(divFixed, params);
    }
  };

  initialDataGrid = grid => {
    this.flexGrid = grid;
    grid.collectionView.collectionChanged.addHandler(() => {
      this.setFormatCellTable();
      this.setMaxHeightGrid();
      this.setMarginTab();
    });
    grid.scrollPositionChanged.addHandler(flexGrid => {
      this.setState({
        isScrollFlag: true,
        isCollapseFlag: false,
      });
      this.tooltip.dispose();
      this.setHeightScrollTable(flexGrid);
    });
    grid.groupCollapsedChanging.addHandler((flexGrid, cellRangeEventArgs) => {
      const { workTypeId } = this.state;
      const selectedItem = flexGrid.selectedItems[0];
      const isCollapse = !workTypeId
        ? !_.isEqual(selectedItem.data_type, DATA_TYPE[0]) &&
          !_.isEqual(selectedItem.data_type, DATA_TYPE[1])
        : !_.isEqual(selectedItem.data_type, DATA_TYPE[workTypeId + 1]) &&
          !_.isEqual(selectedItem.data_type, DATA_TYPE[0]) &&
          !_.isEqual(selectedItem.data_type, DATA_TYPE[1]);
      if (!_.isEmpty(selectedItem.child)) {
        cellRangeEventArgs.cancel = isCollapse;
      }
    });
    grid.groupCollapsedChanged.addHandler((flexGrid, cellRangeEventArgs) => {
      flexGrid.refresh();
      const { params_id } = this.state;
      const { dataItem, isCollapsed } = cellRangeEventArgs.panel.rows[
        cellRangeEventArgs.row
      ];
      let itemCollapsed = {
        lastId: null,
        currentId: null,
      };
      let currentRecords;
      switch (dataItem.data_type) {
        case DATA_TYPE[1]:
          itemCollapsed.lastId = 'last_field_sub_work_type_id';
          itemCollapsed.currentId = 'field_sub_work_type_id';
          currentRecords =
            this.countTimesOfScrollSub * PROGRESS_REQUEST_PARAMS.limit;
          break;
        case DATA_TYPE[2]:
          itemCollapsed.lastId = 'last_a_item_id';
          itemCollapsed.currentId = 'place_id';
          currentRecords =
            this.countTimesOfScrollPlace * PROGRESS_REQUEST_PARAMS.limit;
          break;
        case DATA_TYPE[3]:
          itemCollapsed.lastId = 'last_b_item_id';
          itemCollapsed.currentId = 'place_id';
          currentRecords =
            this.countTimesOfScrollPlace * PROGRESS_REQUEST_PARAMS.limit;
          break;
        case DATA_TYPE[4]:
          itemCollapsed.lastId = 'last_c_item_id';
          itemCollapsed.currentId = 'place_id';
          currentRecords =
            this.countTimesOfScrollPlace * PROGRESS_REQUEST_PARAMS.limit;
          break;
        case DATA_TYPE[5]:
          itemCollapsed.lastId = 'last_d_item_id';
          itemCollapsed.currentId = 'place_id';
          currentRecords =
            this.countTimesOfScrollPlace * PROGRESS_REQUEST_PARAMS.limit;
          break;
        default:
          itemCollapsed.lastId = 'last_field_main_work_type_id';
          itemCollapsed.currentId = 'field_main_work_type_id';
          currentRecords =
            this.countTimesOfScrollMain * PROGRESS_REQUEST_PARAMS.limit;
          break;
      }
      this.setState({
        isScrollFlag: false,
        isCollapseFlag: _.isEqual(
          params_id[itemCollapsed.lastId],
          dataItem[itemCollapsed.currentId]
        ),
        isLastItemCollapsed: isCollapsed,
        totalRecords: _.isEqual(
          params_id[itemCollapsed.lastId],
          dataItem[itemCollapsed.currentId]
        )
          ? dataItem.total_records - currentRecords
          : null,
      });
      this.scrollPositionGrid = flexGrid.scrollPosition.y;
      this.tooltip.dispose();
      this.setHeightScrollTable(flexGrid);
      flexGrid.autoSizeColumns();
      this.setMarginTab();
    });
    grid.resizingColumn.addHandler(() => {
      this.setMarginTab();
    });
    grid.resizedColumn.addHandler(() => {
      this.setMarginTab();
    });
    setDisplayTab(grid, IS_PLAN_TAB_FLG);
    grid.mergeManager = new CustomMergeManager();
  };

  formatItem = (sender, formatItemEvent) => {
    const columnName = sender.columns[formatItemEvent.col].binding;
    const isPanelEqualCell = _.isEqual(formatItemEvent.panel, sender.cells);
    const rowData = formatItemEvent.panel.rows[formatItemEvent.row]._data;
    const domCell = formatItemEvent.cell;
    const { isWorkType, workTypeId } = this.state;

    if (isPanelEqualCell) {
      const {
        start_date,
        end_date,
        plan_work_days,
        current_work_days,
        result_end_date,
        unit_name,
        plan_result_diff_amount,
        plan_result_diff_man_hours,
        plan_result_diff_productivity,
      } = rowData;
      switch (columnName) {
        case 'start_date':
          this.handleWarningInputDate(domCell, start_date);
          break;
        case 'end_date':
          this.handleWarningInputDate(domCell, end_date);
          break;
        case 'name': {
          if (!_.isNull(domCell.lastChild)) {
            domCell.lastChild.textContent = '';
          } else {
            domCell.textContent = '';
          }
          const result = document.createElement('div');
          const text = document.createTextNode(
            _.isNull(rowData.name) ? 'ー' : rowData.name
          );
          setIconArrowForCell(isWorkType, workTypeId, domCell, rowData, result);
          result.appendChild(text);
          result.className = 'wj-overflow';
          domCell.appendChild(result);
          this.tooltip.setTooltip(domCell, rowData.name, PopupPosition.Right);
          break;
        }
        case 'plan_work_days': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'plan_work_days',
            isWorkType,
            workTypeId,
            '日'
          );
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'quantity': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'quantity',
            isWorkType,
            workTypeId,
            ` ${unit_name}`
          );
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'productivity': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'productivity',
            isWorkType,
            workTypeId,
            ` ${unit_name}/人`
          );
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'total_man_days': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'total_man_days',
            isWorkType,
            workTypeId,
            ' 人'
          );
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'mans_per_day': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'mans_per_day',
            isWorkType,
            workTypeId,
            ' 人'
          );
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'elapsed_days': {
          const result = document.createElement('div');
          result.classList.add('unit');
          if (!_.isEmpty(rowData.child)) {
            result.innerHTML = '';
          } else {
            if (start_date) {
              if (end_date) {
                if (result_end_date) {
                  const diffTime = Math.abs(
                    new Date(end_date) - new Date(result_end_date)
                  );
                  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                  if (moment(end_date).isSame(result_end_date)) {
                    result.innerHTML = '完了 (予定通り)';
                  } else if (moment(end_date).isAfter(result_end_date)) {
                    result.innerHTML = `完了 (<span class="text--effective">${diffDays}日前倒</span>)`;
                  } else {
                    result.innerHTML = `完了 (<span class="text--negative">${diffDays}日遅延</span>)`;
                  }
                } else {
                  if (plan_work_days && !_.isEqual(plan_work_days, 0)) {
                    this.setDataDate(
                      start_date,
                      plan_work_days,
                      current_work_days,
                      result
                    );
                  } else if (_.isEqual(plan_work_days, 0)) {
                    result.innerHTML = `${current_work_days}日 (--%)`;
                  } else {
                    result.innerHTML = '--日';
                  }
                }
              } else {
                if (result_end_date) {
                  result.innerHTML = '完了';
                } else {
                  if (plan_work_days && !_.isEqual(plan_work_days, 0)) {
                    this.setDataDate(
                      start_date,
                      plan_work_days,
                      current_work_days,
                      result
                    );
                  } else {
                    result.innerHTML = '--日';
                  }
                }
              }
            } else {
              result.innerHTML = '--日';
            }
          }
          domCell.textContent = '';
          domCell.appendChild(result);
          break;
        }
        case 'plan_man_hours': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'plan_man_hours',
            isWorkType,
            workTypeId,
            ' 人'
          );
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'schedule_man_hours': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'schedule_man_hours',
            isWorkType,
            workTypeId,
            ' 人'
          );
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'result_man_hours': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'result_man_hours',
            isWorkType,
            workTypeId,
            ' 人'
          );
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'plan_result_diff_man_hours': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'plan_result_diff_man_hours',
            isWorkType,
            workTypeId,
            ' 人'
          );
          this.handleChangeColorText(domCell, plan_result_diff_man_hours);
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'plan_amount': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'plan_amount',
            isWorkType,
            workTypeId,
            ` ${unit_name}`
          );
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'result_amount': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'result_amount',
            isWorkType,
            workTypeId,
            ` ${unit_name}`
          );
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'plan_result_diff_amount': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'plan_result_diff_amount',
            isWorkType,
            workTypeId,
            ` ${unit_name}`
          );
          this.handleChangeColorText(domCell, plan_result_diff_amount);
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'plan_productivity': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'plan_productivity',
            isWorkType,
            workTypeId,
            ` ${unit_name}/人`
          );
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'result_productivity': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'result_productivity',
            isWorkType,
            workTypeId,
            ` ${unit_name}/人`
          );
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'plan_result_diff_productivity': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'plan_result_diff_productivity',
            isWorkType,
            workTypeId,
            ` ${unit_name}/人`
          );
          this.handleChangeColorText(domCell, plan_result_diff_productivity);
          this.handleAddUnitName(domCell, unit);
          break;
        }
      }
    }
  };

  render() {
    const {
      notHaveItems,
      selectedItemId,
      visibleDialogName,
      visibleConfirmDialogCSV,
      titleErr,
      buttonTextErr,
      isShowPopupError,
      messageError,
      errMessage,
      startDate,
      endDate,
      inputStartDate,
      inputEndDate,
      isCheckAll,
      isWorkType,
      workTypeId,
      displayBatch,
      aggregatedBatchDateTime,
      batchStatusText,
      marginTab,
      isPlanTagFlg,
      listTypeLocation,
      isTableLoading,
    } = this.state;
    const checkExistDate = !_.isNull(startDate);
    let textDate = '未設定';
    if (checkExistDate) {
      textDate = `${startDate} ~ ${endDate}`;
      if (_.isNull(endDate)) {
        textDate = `${startDate} ~ 未設定`;
      }
    }

    if (!this.isProgressFlg) {
      return null;
    }

    return (
      <div className='master-slide-view show ProgressSchedule'>
        <Helmet>
          <link rel='icon' href={IconProgress} />
          <title>{TITLE_BROWSER_PROGRESS.progressSchedule}</title>
        </Helmet>
        <div className='master-slide-view__view'>
          <MasterPageHeader
            title={HEADER_CONSTANTS_PROGRESS.progressSchedule}
            disableHelpMenu
            rightComponent={
              !notHaveItems && (
                <ComponentDateTime
                  title='進捗歩掛集計期間'
                  date={textDate}
                  textButton='集計期間設定'
                  onClick={() =>
                    this.handleVisibleDialog('visibleDialogName', true)
                  }
                />
              )
            }
          />
          <div className='master-slide-view__table'>
            <div className='ProgressSchedule__header'>
              <div className='master-slide-view__menu'>
                <ul className='btn-menu ProgressSchedule__header--menu'>
                  {!notHaveItems ? (
                    <li className='btn-menu__item'>
                      {!_.isEmpty(selectedItemId) ? (
                        <button
                          className='btn'
                          onClick={() => {
                            SessionStorageService.setItemIds(
                              JSON.stringify(selectedItemId)
                            );
                            SessionStorageService.setAxisType(workTypeId);
                            window.location.href =
                              '/progress/0:1/0/0/ProgressScheduleEdit:1/0:0';
                          }}
                        >
                          {isPlanTagFlg ? '実績入力' : '計画入力'}
                        </button>
                      ) : (
                        <div>
                          <ToolTip
                            content='工種が未選択です。下の一覧にて編集したい大工種にチェックを入れてください。'
                            value={
                              <button className='btn--disabled' disabled>
                                {isPlanTagFlg ? '実績入力' : '計画入力'}
                              </button>
                            }
                          />
                        </div>
                      )}
                    </li>
                  ) : (
                    <button className='btn--disabled' disabled>
                      {isPlanTagFlg ? '実績入力' : '計画入力'}
                    </button>
                  )}
                  {!notHaveItems && (
                    <Fragment>
                      <TouchDeviceInvisible>
                        <div className='segment-line' />
                      </TouchDeviceInvisible>
                      <li className='btn-menu__item'>
                        <button
                          className='btn--sub'
                          onClick={() => {
                            window.location.href =
                              '/progress/0:1/0/0/ProgressChangeOrderOfWorkType:1/0:0';
                          }}
                        >
                          工種の並び順変更
                        </button>
                      </li>
                    </Fragment>
                  )}
                </ul>
              </div>
              {!notHaveItems && (
                <React.Fragment>
                  <div className='ProgressSchedule__select'>
                    <div className='ProgressSchedule__select--wrapper'>
                      <div className='ProgressSchedule__select--right'>
                        <span className='ProgressSchedule__select--title'>
                          表示軸
                        </span>
                        <select
                          className='ProgressSchedule__select--dropdown'
                          name='in_hour'
                          onChange={this.handleChangeTypeOption}
                        >
                          {_.map(listTypeLocation, item => {
                            return (
                              <option value={item.id} key={item.id}>
                                {item.name}
                              </option>
                            );
                          })}
                        </select>
                        <div className='ProgressSchedule__schedule'>
                          <div>
                            <span className='ProgressSchedule__schedule--title'>
                              集計状況
                            </span>
                          </div>
                          {displayBatch ? (
                            <CompleteBatchStatus
                              aggregatedBatchDateTime={aggregatedBatchDateTime}
                              batchStatusText={batchStatusText}
                            />
                          ) : (
                            <NoHaveBatchStatus
                              aggregatedBatchDateTime={aggregatedBatchDateTime}
                              batchStatusText={batchStatusText}
                            />
                          )}
                        </div>
                      </div>
                      <div className='ProgressSchedule__select--left'>
                        <button
                          className='btn--sub'
                          onClick={() => {
                            this.handleVisibleDialog(
                              'visibleConfirmDialogCSV',
                              true
                            );
                          }}
                        >
                          CSV出力
                        </button>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              )}
            </div>
            <div
              className={notHaveItems ? 'ProgressSchedule--no-data' : undefined}
            >
              <TabPanel
                marginTab={marginTab}
                setDisplayTab={type => this.setProgressTabFlag(type)}
              />
              <FlexGrid
                columnGroups={this.columnGroupInit}
                itemsSource={this.listItems}
                childItemsPath={this.childItemsPath}
                frozenColumns={1}
                allowDragging={0}
                allowSorting={false}
                autoGenerateColumns={false}
                quickAutoSize={true}
                formatItem={this.formatItem}
                initialized={this.initialDataGrid}
              >
                <FlexGridCellTemplate
                  cellType='TopLeft'
                  template={() => {
                    if (isTableLoading) {
                      return null;
                    }
                    if (notHaveItems) {
                      return (
                        <label htmlFor='checkbox' className='wj-checkall'>
                          <input
                            id='checkbox'
                            type='checkbox'
                            disabled={true}
                          />
                          <span className='wj-checkmark' />
                        </label>
                      );
                    }
                    return (
                      <React.Fragment>
                        {isCheckAll ? (
                          <input
                            type='checkbox'
                            className='wj-checkbox'
                            checked={true}
                            onChange={this.setCheckAll}
                          />
                        ) : (
                          <React.Fragment>
                            {_.isEmpty(selectedItemId) ? (
                              <input
                                type='checkbox'
                                className='wj-checkbox'
                                checked={false}
                                onChange={this.setCheckAll}
                              />
                            ) : (
                              <label htmlFor='checkbox' className='wj-checkall'>
                                <input
                                  id='checkbox'
                                  type='checkbox'
                                  onChange={this.setCheckAll}
                                />
                                <span className='wj-checkmark' />
                              </label>
                            )}
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    );
                  }}
                />
                <FlexGridCellTemplate
                  cellType='RowHeader'
                  template={context => {
                    if (
                      (isWorkType &&
                        _.isEqual(context.item.data_type, DATA_TYPE[0])) ||
                      (!isWorkType &&
                        _.isEqual(
                          context.item.data_type,
                          DATA_TYPE[workTypeId + 1]
                        ))
                    ) {
                      return (
                        <input
                          type='checkbox'
                          className='wj-checkbox'
                          onChange={e => this.setCheckbox(e, context)}
                          checked={_.includes(
                            selectedItemId,
                            _.get(
                              context,
                              isWorkType
                                ? 'item.field_main_work_type_id'
                                : 'item.place_id'
                            )
                          )}
                        />
                      );
                    }
                  }}
                />
              </FlexGrid>
              {isTableLoading ? (
                <div className='indicator' />
              ) : (
                notHaveItems && (
                  <div className='ProgressSchedule--no-data__content'>
                    工種が選択されていません。機能一覧の「使用工種選択」から設定を行ってください。
                  </div>
                )
              )}
            </div>
          </div>
        </div>
        <Confirmation
          visible={visibleDialogName}
          rootClassName='ProgressWorkScheduleDialog'
          message={
            <ComponentInputDate
              handleChangeInputDate={this.handleChangeInputDate}
              handleChangeInputEndDate={this.handleChangeInputEndDate}
              inputStartDate={inputStartDate}
              inputEndDate={inputEndDate}
              errMessage={errMessage}
            />
          }
          multilineText={true}
          title='進捗・歩掛集計設定'
          confirmButtonText={messageUtility.getMessage('I-000-088')}
          cancelButtonText={messageUtility.getMessage('I-000-017')}
          onCancel={this.handleCancelDialog}
          onConfirm={this.handleFieldSettings}
        />
        <Confirmation
          visible={visibleConfirmDialogCSV}
          rootClassName='ProgressDialogCSV'
          message={messageUtility.getMessage('I-001-454')}
          multilineText={true}
          title='CSV出力'
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          confirmButtonText='CSV出力'
          onCancel={() => {
            this.handleVisibleDialog('visibleConfirmDialogCSV', false);
          }}
          onConfirm={this.downloadProgressCSV}
        />
        <Information
          visible={isShowPopupError}
          message={messageError}
          title={titleErr}
          multilineText={true}
          buttonText={buttonTextErr}
          onClose={() => window.location.reload()}
        />
      </div>
    );
  }
}

const ComponentDateTime = ({ title, date, textButton, onClick }) => {
  const checkExistDate = _.isEqual(date, '未設定');
  return (
    <div className='ProgressSchedule__schedule'>
      <div>
        <span className='ProgressSchedule__schedule--title'>{title}</span>
      </div>
      <span className={checkExistDate ? 'text--negative' : null}>{date}</span>
      <button className='btn btn-schedule' onClick={onClick}>
        {textButton}
      </button>
      <ToolTip
        content={
          <React.Fragment>
            <span className='ProgressSchedule__schedule--tooltip'>
              調整会議の作業予定・実績に工種の欄を表示したい期間を設定します。この期間は実際に入力を行った日ではなく、作業予定・実績の「日付」に連動します。
            </span>
            <br />
            <br />
            <span className='ProgressSchedule__schedule--tooltip'>
              例えば、入力期間を12/01〜12/31に設定すると、実際に入力を行った日時にかかわらず、「日付を12/01にした作業予定」には工種が表示されます。
            </span>
          </React.Fragment>
        }
        value={<QuestionIcon className='icon--1_6x question-icon' />}
      />
    </div>
  );
};

const ComponentInputDate = ({
  inputStartDate,
  inputEndDate,
  handleChangeInputDate,
  handleChangeInputEndDate,
  errMessage,
}) => {
  const input = ['inputStartDate', '~', 'inputEndDate'];
  return (
    <div className='ProgressWorkScheduleDialog'>
      <div>
        <span>進捗歩掛の実績を集計する期間を設定してください。</span>
        <br />
        <br />
        <span>
          ここで設定した期間で調整会議の作業予定・実績に大工種・小工種の項目が表示されます。
        </span>
      </div>
      <div className='ProgressWorkScheduleDialog__input'>
        <div className='ProgressWorkScheduleDialog__input--date'>
          {_.map(input, (item, index) => {
            if (!_.isEqual(item, '~')) {
              return (
                <wjInput.InputDate
                  key={index}
                  format='yyyy/MM/dd'
                  value={
                    _.isEqual(item, 'inputStartDate')
                      ? inputStartDate
                      : inputEndDate
                  }
                  valueChanged={sender => handleChangeInputDate(sender, item)}
                  textChanged={sender =>
                    _.isEmpty(sender.text) &&
                    _.isEqual(item, 'inputEndDate') &&
                    handleChangeInputEndDate(item)
                  }
                  lostFocus={sender => {
                    if (_.isEqual(item, 'inputStartDate')) {
                      handleChangeInputDate(sender, item, 'focusOut');
                    }
                  }}
                />
              );
            } else {
              return (
                <p key={index} className='ProgressWorkScheduleDialog__entities'>
                  〜
                </p>
              );
            }
          })}
        </div>
        {errMessage && <p className='text--negative'>{errMessage}</p>}
      </div>
    </div>
  );
};

export class CustomMergeManager extends wjGrid.MergeManager {
  getMergedRange(panel) {
    if (_.isEqual(panel.cellType, wjGrid.CellType.TopLeft)) {
      return new wjGrid.CellRange(
        0,
        0,
        panel.rows.length - 1,
        panel.columns.length - 1
      );
    } else {
      return wjGrid.MergeManager.prototype.getMergedRange.apply(
        this,
        arguments
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/ProgressSchedule.jsx